import { Box, BoxProps, Icon, Tooltip } from "@chakra-ui/react";
import { MdAnchor, MdStorefront } from "react-icons/md";
import { ComponentType, ReactNode, SVGProps } from "react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";

const fragment = gql(/* GraphQL */ `
  fragment RetailerFlagIcons on Retailer {
    isAnchor
    parent {
      id
      nameWithUniqueSuffix
    }
  }
`);

type TooltipIconProps = BoxProps & {
  label: ReactNode;
  IconComponent: ComponentType<SVGProps<SVGElement>>;
};

function TooltipIcon({ label, IconComponent }: TooltipIconProps) {
  return (
    <Tooltip label={label} hasArrow whiteSpace="nowrap" maxW="50vw">
      <Box
        as="span"
        display="inline-block"
        top=".125em"
        position="relative"
        color="magenta.dark"
        sx={{ "tr[aria-selected=true] &": { color: "white" } }}
      >
        <Icon as={IconComponent} />
      </Box>
    </Tooltip>
  );
}

export type RetailerFlagIconsFragment = FragmentType<typeof fragment>;

type Props = {
  data: RetailerFlagIconsFragment;
};

export default function RetailerFlagIcons({ data: dataFragment }: Props) {
  const data = getFragmentData(fragment, dataFragment);
  return (
    <>
      {data.parent && (
        <TooltipIcon
          label={
            <>
              This retailer is a banner of{" "}
              <strong>{data.parent.nameWithUniqueSuffix}</strong>
            </>
          }
          IconComponent={MdStorefront}
        />
      )}

      {data.isAnchor && (
        <TooltipIcon
          label="This retailer is an anchor account"
          IconComponent={MdAnchor}
        />
      )}
    </>
  );
}
